export const createConsoleLog = (prefix, { debug }) => (...args) => {
  if (debug) {
    console.log(`[${prefix}] `, ...args);
  }
};
